<template>
<div :ref="cateobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增教程</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="vediolist.length > 1 ? vediolist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="clearAll">清空已填模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="addpetmodel">新增模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回版本管理</el-button>
        </div>
    </div>
    

    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in vediolist" :key="index">
            <div class="TTL-form-submit-box-title">教程-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" 
                v-if="vediolist.length > 1" 
                @click.stop="()=> {
                    vediolist.splice(index,1);
                    SaveDataToBrowser();
                }"
            >删除</el-button>
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">封面图<i>*</i></label>
                    <wcupload 
                        :value="item.cover"
                        :option="{size:'large', phototype:'system'}"
                        @finish="(val)=> {
                            item.cover=val.url;
                            SaveDataToBrowser();
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">上传文件<i>*</i></label>
                    <wcvideoupload 
                        :value="item.url"
                        @finish="(val)=> {
                            item.url=val.url;
                            SaveDataToBrowser();
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">教程名称<i>*</i></label>
                    <wcinput 
                        :option="{placeholder:'请填写教程名称',clearable:true,type:'input',isinput:true,width:300,ischange:true}"
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.name=val.value;
                                SaveDataToBrowser();
                            }else if(val.type=='input') {
                                item.name=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">所属分类<i>*</i></label>
                    <wccascader
                        :value="item.scateid > 0 ? [item.pcateid,item.scateid] : [item.pcateid]"
                        :list="catelists"
                        :option="{placeholder:'请选择分类',clearable:true,filterable:true,width:300}"
                        @finish="(val)=> {
                            item.pcateid=val.pcateid > 0 ? val.pcateid : '';
                            item.pcatename=val.pcatename;
                            item.scateid=val.scateid > 0 ? val.scateid : '';
                            item.scatename=val.scatename;
                            SaveDataToBrowser();
                        }"
                     />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">教程描述</label>
                    <wcinput 
                        :option="{placeholder:'请填写教程简介',clearable:true,type:'input',objtype:'textarea',isinput:true,width:300,ischange:true}"
                        :value="item.content"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.content=val.value;
                                SaveDataToBrowser();
                            }else if(val.type=='input') {
                                item.content=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
            </el-form>
        </div>
    </div>


</div>
</template>

<script>
import INTERFACE_MODEL_PLAT_VEDIO from '@/Interface/Platsetting/PlatVedio';
export default {
    components:{},
    data() {
        return {
            cateobj:'platformvideoadd',
            browsername:'platformvideoadd',
            addlimit: 10,                                                                                       //单次新增限制
            vedioinfo:{name:'',content:'',cover:'',pcateid:'',pcatename:'',scateid:'',scatename:'',url:''},     //教程信息
            vediolist:[],                                                                                       //教程信息列表
            catelists:[],                                                                                       //分类信息
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetCateAll(); //获取一级分类信息
            this.ParseDataFromBrowser(); //解析数据
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                
            } 
        },


        /** 提交数据 **/
        submitData() {
            //调整提交数据
            var data=[];
            for(var i=0;i<this.vediolist.length;i++) data.push(this.vediolist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs[this.cateobj];
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_PLAT_VEDIO.ADD_TUTORIALS({data:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
                this.GoBackPets(true);
            });
        },



        /** 清空当前数据 **/
        clearAll() {
            this.$confirm.confirm(
                '您是否确定要删除当前所有账号信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.resetParam();
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            }).catch(()=> {

            });
        },

        
        /** 新增品种模板信息 **/
        addpetmodel() {
            if(this.vediolist.length >= this.addlimit) {
                this.$notice({title:'消息提示',message:'单次添加版本数量请最多不要超过'+this.addlimit+'个',type:'warning'});
                return false;
            }

            var info=this.GetVedioInfo();
            this.vediolist.push(info);
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.vediolist);
            localStorage.setItem(this.browsername,data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem(this.browsername);
            data ? data : data=[];
            !data || data=='' || data==[] ? this.resetParam() : this.vediolist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'使用教程',labelentry:'PlatFormVideo',components:'PlatFormVideo',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

        /** 重置加载数据 **/
        resetParam() {
            this.vediolist=[];
            var info=this.GetVedioInfo();
            this.vediolist.push(info);
            this.SaveDataToBrowser();
        },

        /** 获取分类信息 **/
        GetVedioInfo() {
            var info={};
            for(var i in this.vedioinfo) info[i]=this.vedioinfo[i];
            return info;
        },


        /** 获取一级分类信息大全 **/
        GetCateAll() {
            this.catelists=[];
            this.$method.GET_PLAT_VEDIO_CATE_ALL(true).then((res) => {
                this.parentvediolist=res.pcate;
                this.scatevediolist=res.scate;
                var data={};
                for(var i in res.pcate) {
                    data={value:res.pcate[i].id,label:res.pcate[i].name,children:[]};
                    for(var ii in res.scate) {
                        if(res.pcate[i].id==res.scate[ii].pid) data.children.push({value:res.scate[ii].id,label:res.scate[ii].name});
                    }
                    this.catelists.push(data);
                }
                console.log(this.catelists);
            });
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.TTL-form-submit-box-title {margin-bottom:40px;}
</style>